import { Helmet } from "react-helmet-async";

export default function SeoRoute({ canonical, children }) {
  return (
    <>
      <Helmet prioritizeSeoTags>
        <link rel="canonical" href={canonical} />
      </Helmet>
      {children}
    </>
  );
}
